import { InputText } from "./textBoxStyles/textBox.style";
import PropTypes from "prop-types";
const TextBox = ({
  placeHolder,
  width,
  onChange,
  value,
  onClick,
  onBlur,
  icon,
  height,
  disabled,
  keyPress,
  rounded,
  centerText,
  password,
  defaultValue,
  key,
  id,
  required = false,
  name,
  autoComplete,
  multiline = false,
  sx,
  type,
}) => {
  return (
    <InputText
      required={required}
      id={id}
      name={name}
      placeholder={placeHolder}
      size="small"
      width={width}
      height={height}
      onChange={onChange}
      value={value}
      onClick={onClick}
      onBlur={onBlur}
      disabled={disabled}
      onKeyPress={keyPress}
      InputProps={icon && { endAdornment: icon }}
      inputProps={{ style: { textAlign: `${centerText && "center"}` } }}
      rounded={rounded}
      type={type}
      defaultValue={defaultValue}
      key={key}
      autoComplete={autoComplete}
      multiline={multiline}
      sx={sx}
    />
  );
};

TextBox.propTypes = {
  placeHolder: PropTypes.string,
  required: PropTypes.bool,
  width: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.string,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  icon: PropTypes.node,
  height: PropTypes.number,
  disabled: PropTypes.bool,
  keyPress: PropTypes.func,
  rounded: PropTypes.bool,
  centerText: PropTypes.bool,
  password: PropTypes.bool,
  multiline: PropTypes.bool,
  defaultValue: PropTypes.any,
  key: PropTypes.any,
  id: PropTypes.any,
  name: PropTypes.string,
  autoComplete: PropTypes.string,
  sx: PropTypes.any,
  type: PropTypes.string,
};

export default TextBox;
